<div style="padding: 0px 15px 15px;">

  <div class="current-pends-header bold fontsize">Notification</div>
  <div *ngFor="let item of notificationList;trackBy: trackByIndex">
    <div class="current-pends-header bold">
      {{item.specificDay}}<span> ({{item.notificationGroup.length}})</span>
    </div>
    <div class="current-pends-container" *ngFor="let value of item.notificationGroup;trackBy: trackByIndex">
    <ng-container *ngIf="isMentionAlert(value)">
      <div class="current-pends-detail">
          {{value.supplemental.createdBy.first}} {{value.supplemental.createdBy.last}} mentioned you on {{value.objectType}}
          <a class="link" href="{{value.alertURL}}">{{ value.objectId }}</a>
      </div>
    </ng-container>
    <ng-container *ngIf="!isMentionAlert(value) && value.objectType?.toLowerCase() === 'chart download'">
      <div class="current-pends-detail">
        <span>Chart with Chart ID
        <a class="link" (click)="onDownloadChartClick($event, value)">{{value.message}}</a>
        ready for download</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!isMentionAlert(value) && value.objectType?.toLowerCase() !== 'chart download'">
      <div class="current-pends-detail">
        {{value.objectType}}  
        <a class="link" *ngIf="value.objectId!=0" [routerLink]="[value.alertURL]">{{value.objectId}}</a> {{value.message}}
      </div>
    </ng-container>
      <div>
        <span>{{value.timeStamp | date:"short"}}</span>
      </div>
    </div>
  </div>
  <app-pagination [rows]="rows"
                  [totalRecords]="totalRecords"
                  (onPageChange)="onPageChange($event)">
  </app-pagination>
</div>
